function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import { LayoutUtils } from '@deephaven/dashboard';
import { assertNotNull } from '@deephaven/utils';
import Panel from "./CorePanel.js";
import InputFilter from "../controls/input-filter/InputFilter.js";
import { getColumnsForDashboard } from "../redux/index.js";
import { emitFilterChanged } from "../FilterEvents.js";
import { jsx as _jsx } from "react/jsx-runtime";
var INPUT_FILTER_DEBOUNCE = 250;
class InputFilterPanel extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "inputFilterRef", void 0);
    this.handleChange = debounce(this.handleChange.bind(this), INPUT_FILTER_DEBOUNCE);
    this.handleClearAllFilters = this.handleClearAllFilters.bind(this);
    this.inputFilterRef = /*#__PURE__*/React.createRef();
    var panelState = props.panelState;
    // if panelstate is null, use destructured defaults
    var _ref = panelState !== null && panelState !== void 0 ? panelState : {},
      value = _ref.value,
      _ref$isValueShown = _ref.isValueShown,
      isValueShown = _ref$isValueShown === void 0 ? false : _ref$isValueShown,
      name = _ref.name,
      type = _ref.type,
      _ref$timestamp = _ref.timestamp,
      timestamp = _ref$timestamp === void 0 ? Date.now() : _ref$timestamp;
    this.state = {
      columns: [],
      column: name != null && type != null ? {
        name,
        type
      } : undefined,
      value,
      timestamp,
      isValueShown,
      wasFlipped: false,
      skipUpdate: false,
      // eslint-disable-next-line react/no-unused-state
      panelState // Dehydrated panel state that can load this panel
    };
  }
  componentDidMount() {
    this.updateColumns();
    var _this$state = this.state,
      column = _this$state.column,
      value = _this$state.value,
      timestamp = _this$state.timestamp;
    if (column != null) {
      var name = column.name,
        type = column.type;
      this.sendUpdate(name, type, value, timestamp);
    }
  }
  componentDidUpdate(prevProps) {
    var columns = this.props.columns;
    if (columns !== prevProps.columns) {
      this.updateColumns();
    }
  }
  handleChange(_ref2) {
    var column = _ref2.column,
      _ref2$isValueShown = _ref2.isValueShown,
      isValueShown = _ref2$isValueShown === void 0 ? false : _ref2$isValueShown,
      value = _ref2.value;
    var name;
    var type;
    if (column != null) {
      name = column.name;
      type = column.type;
    }
    var sendUpdate = true;
    var timestamp = Date.now();
    this.setState(_ref3 => {
      var _ref4;
      var panelState = _ref3.panelState,
        prevTimestamp = _ref3.timestamp,
        wasFlipped = _ref3.wasFlipped,
        skipUpdate = _ref3.skipUpdate;
      // If the user had a value set, and they flip the card over and flip it back without changing any settings, ignore it
      var isFlip = panelState != null && isValueShown !== panelState.isValueShown && name === panelState.name && type === panelState.type && value === panelState.value;
      sendUpdate = (_ref4 = !skipUpdate && isValueShown && (!isFlip || !wasFlipped)) !== null && _ref4 !== void 0 ? _ref4 : false;
      if (!sendUpdate) {
        timestamp = prevTimestamp;
      }
      return {
        panelState: {
          isValueShown,
          name,
          type,
          value,
          timestamp
        },
        timestamp,
        wasFlipped: isFlip,
        skipUpdate: false
      };
    }, () => {
      if (sendUpdate) {
        this.sendUpdate(name, type, value, timestamp);
      }
    });
  }
  handleClearAllFilters() {
    var _this$inputFilterRef$;
    (_this$inputFilterRef$ = this.inputFilterRef.current) === null || _this$inputFilterRef$ === void 0 || _this$inputFilterRef$.clearFilter();
  }
  sendUpdate(name, type, value, timestamp) {
    var glEventHub = this.props.glEventHub;
    var panelId = LayoutUtils.getIdFromPanel(this);
    assertNotNull(panelId);
    emitFilterChanged(glEventHub, panelId, name != null && type != null && value != null && timestamp != null ? {
      name,
      type,
      value,
      timestamp
    } : null);
  }

  /**
   * Set the filter value, card side, selected column
   * @param state Filter state to set
   * @param sendUpdate Emit filters changed event if true
   */
  setPanelState(state) {
    var _this$inputFilterRef$2;
    var sendUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    // Set the skipUpdate flag so the next onChange handler call doesn't emit the FILTERS_CHANGED event
    this.setState({
      skipUpdate: !sendUpdate
    });

    // Changing the inputFilter state via props doesn't quite work because of the delays on manual input changes
    // Setting the ref state directly triggers the onChange handler and updates the panelState
    (_this$inputFilterRef$2 = this.inputFilterRef.current) === null || _this$inputFilterRef$2 === void 0 || _this$inputFilterRef$2.setFilterState(state);
  }
  updateColumns() {
    var columns = this.props.columns;
    if (columns == null) {
      return;
    }
    this.setState(state => {
      var column = state.column;
      if (column == null && columns.length > 0) {
        return {
          columns: [...columns],
          column: columns[0]
        };
      }
      if (column != null && !columns.find(_ref5 => {
        var name = _ref5.name,
          type = _ref5.type;
        return column.name === name && column.type === type;
      })) {
        return {
          columns: [...columns, column]
        };
      }
      return {
        columns: [...columns]
      };
    });
  }
  render() {
    var _this$props = this.props,
      glContainer = _this$props.glContainer,
      glEventHub = _this$props.glEventHub;
    var _this$state2 = this.state,
      column = _this$state2.column,
      columns = _this$state2.columns,
      isValueShown = _this$state2.isValueShown,
      value = _this$state2.value;
    return /*#__PURE__*/_jsx(Panel, {
      className: "iris-input-filter-panel",
      componentPanel: this,
      glContainer: glContainer,
      glEventHub: glEventHub,
      onClearAllFilters: this.handleClearAllFilters,
      isClonable: true,
      isRenamable: true,
      children: /*#__PURE__*/_jsx(InputFilter, {
        ref: this.inputFilterRef,
        column: column,
        columns: columns,
        onChange: this.handleChange,
        isValueShown: isValueShown,
        value: value
      })
    });
  }
}
_defineProperty(InputFilterPanel, "defaultProps", {
  panelState: null
});
_defineProperty(InputFilterPanel, "COMPONENT", 'InputFilterPanel');
// Have to explicitly specify displayName
// otherwise it gets minified and breaks LayoutUtils.getComponentName
_defineProperty(InputFilterPanel, "displayName", 'InputFilterPanel');
var mapStateToProps = (state, ownProps) => {
  var localDashboardId = ownProps.localDashboardId;
  return {
    columns: getColumnsForDashboard(state, localDashboardId)
  };
};
var ConnectedInputFilterPanel = connect(mapStateToProps, null, null, {
  forwardRef: true
})(InputFilterPanel);
export default ConnectedInputFilterPanel;
//# sourceMappingURL=InputFilterPanel.js.map